var lastUserRouteAction = Date.now();
var getLastAction = function getLastAction2() {
  return lastUserRouteAction;
};
var setLastAction = function setLastAction2() {
  lastUserRouteAction = Date.now();
};
export {
  getLastAction,
  setLastAction
};
//# sourceMappingURL=lastAction.js.map
